export const jobListings = [
  {
    slug: 'hr-admin',
    title: 'Office Admin',
    tag: 'HOT',
    location: 'Ho Chi Minh, Viet Nam',
    type: 'Employee',
    department: 'Back office',
    salary: 'Negotiable salary',
    postedDate: 'September 2, 2025',
    about: 'We are looking for a responsible and organized Office Admin to manage day-to-day office operations and support staff. The ideal candidate will be detail-oriented with strong communication skills.',
    responsibilities: [
      'Handle job postings across different platforms.',
      'Screen CVs and shortlist qualified candidates.',
      'Reach out to candidates and coordinate interviews.',
      'Set up and participate in interview sessions.',
      'Prepare and send offer letters.',
      'Maintain and update candidate pipelines.',
      'Support onboarding for new hires.',
      'Assist with offboarding processes.',
      'Receive correspondence and goods sent to the Company and hand them over to relevant departments.',
      'Manage stationery and office supplies.',
      'Track annual leave, timekeeping and bonus for company employees monthly and yearly.',
      'Other duties as assigned by the Board of Directors.',
    ],
    requirements: [
      'Good command of English communication.',
      'Graduated in Finance, Accounting, Human Resource Management, Business Administration, or related fields.',
      'Multi-tasking and time-management skills, with the ability to prioritize tasks.',
      'Proficient in Microsoft Office.',
      'Knowledge of Labor Law, Social Insurance Law and PIT Law.',
      'Strong communication, processing and data analysis skills.',
      'Only CV submitted in English will be considered.',
    ],
    benefits: [
      'Working in one of the young dynamic European-based companies.',
      'Join a dynamic and fast-growing global company (English-speaking environment).',
      'Over 14 days of annual leave.',
      'Annually teambuilding and tech talk together with the company.',
      'Free on-site food, coffee and fresh juice.',
    ],
  },
  {
    slug: 'full-stack-developer-onsite-remote-hybrid',
    title: 'Full Stack Developer (Onsite and/or Remote/Hybrid – Vietnam-based)',
    tag: null,
    location: 'Remote - Vietnam',
    type: 'Employee',
    department: 'Software development',
    salary: 'Negotiable salary',
    postedDate: 'July 10, 2025',
    about: 'At DISION Tech, we build world-class software products and robust web applications while advancing cybersecurity, DevOps, and IT consulting. By integrating AI-driven workflows into our projects, we boost efficiency, creativity, and innovation.',
    responsibilities: [
      'Develop user interfaces using JavaScript, React, and TypeScript.',
      'Integrate APIs and ensure responsive, cross-device functionality.',
      'Apply AI-assisted coding (e.g., ChatGPT, Copilot) professionally – not blindly.',
      'Work within existing templates and project structures, not just from scratch.',
      'Ensure code is clean, consistent, and aligned with project standards.',
      'Collaborate with global teams to deliver high-quality, maintainable solutions.',
    ],
    requirements: [
      'Strong experience with React and Next.js.',
      'Ability to prototype in Node.js/Express.js.',
      'Understanding of modern frontend architecture and UX/UI practices.',
      'Confident in vibe coding — especially when working with existing codebases.',
      'Comfortable with rules, coding standards, and structured workflows.',
      'Fluent English communication (written and spoken) – required.',
      'Python is expected as a base skill.',
    ],
    benefits: [
      'Advanced Technology: Work with cutting-edge tools in a global environment with European culture.',
      'AI Tool Allowance: Monthly allowance for your preferred AI coding assistant subscription.',
      'Dynamic Projects: Join meaningful cybersecurity initiatives.',
      'Career Growth: Learn from senior engineers and grow professionally.',
      'Flexible work model: hybrid, onsite, or remote options available.',
    ],
    techStack: ['React', 'Next.js', 'Golang', 'ChatGPT / Copilot', 'CI/CD', 'REST'],
  },
  {
    slug: 'network-and-network-security-engineer',
    title: 'Network and Network Security Engineer',
    tag: null,
    location: 'Ho Chi Minh, Viet Nam',
    type: 'Employee',
    department: 'System development',
    salary: 'Negotiable salary',
    postedDate: 'March 15, 2025',
    about: 'Join our cybersecurity team as a Network Security Engineer. You will be responsible for designing, implementing, and maintaining network security architectures to protect our clients from modern cyber threats.',
    responsibilities: [
      'Design and implement network security architectures for enterprise clients.',
      'Monitor network traffic for suspicious activity using SIEM tools.',
      'Configure and manage firewalls, IDS/IPS, VPN solutions.',
      'Conduct network security assessments and penetration testing.',
      'Respond to network security incidents and coordinate remediation.',
      'Develop and maintain network security documentation and policies.',
      'Collaborate with development teams to embed security into CI/CD pipelines.',
    ],
    requirements: [
      '2+ years of experience in network security or a related field.',
      'Strong knowledge of TCP/IP, routing protocols, and network architecture.',
      'Hands-on experience with Cisco, Palo Alto, Fortinet, or similar vendors.',
      'Familiarity with SIEM platforms (Splunk, QRadar, or similar).',
      'Understanding of Zero Trust architecture principles.',
      'Security certifications (CCNA Security, CISSP, CEH) are a plus.',
      'Good English communication skills.',
    ],
    benefits: [
      'Advanced Technology: Work with cutting-edge network security tools.',
      'Dynamic Projects: Work on impactful cybersecurity projects.',
      'Career Growth: Opportunities for mentorship and ongoing professional development.',
      'Competitive Compensation: Competitive salary and bonuses.',
      'Over 14 days of annual leave.',
      'Free parking and on-site food and coffee.',
    ],
  },
  {
    slug: 'backend-developer',
    title: 'Backend Developer',
    tag: null,
    location: 'Ho Chi Minh, Viet Nam',
    type: 'Employee',
    department: 'Software development',
    salary: 'Negotiable salary',
    postedDate: 'April 9, 2023',
    about: 'Join DISION Tech LLC and empower our applications through robust backend solutions as part of our international team. Utilize advanced backend technologies and collaborate on global scale projects.',
    responsibilities: [
      'Develop backend components, gateways, and APIs using Golang and Python.',
      'Ensure seamless API integration and functionality across multiple devices.',
      'Work collaboratively with international teams to deliver high-quality solutions.',
    ],
    requirements: [
      'Proficiency in Golang and Python with 1-3 years of working experience.',
      'Experience with SQL and NoSQL databases like MongoDB, Postgres, and Redis.',
      'Solid understanding of microservices architecture and RESTful APIs.',
      'Ability to communicate effectively in English and collaborate in multinational environments.',
    ],
    techStack: ['Golang', 'Python', 'Fiber', 'Echo', 'Flask', 'Django', 'MongoDB', 'Postgres', 'Redis', 'Docker', 'Ansible'],
    benefits: [
      'Advanced Technology: Engage with cutting-edge technologies in an international team.',
      'Dynamic Projects: Work on impactful cybersecurity projects.',
      'Career Growth: Opportunities for mentorship with senior leadership.',
      'Competitive Compensation: Competitive salary, bonuses, and 13th-month salary.',
      'Generous Leave Policy: Over 14 days of annual leave.',
      'Flexible Working Hours: Flexible start (8-10 am) and end times (5-7 pm).',
      'Free parking and on-site food and coffee facilities.',
    ],
  },
];
